// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"351c2fb7","667":"59a8fbed"}[chunkId] + ".chunk.js";
};